import React from "react";

function TextError(props) {
  return <div className="errorMobile">{props.children}</div>;
}

export default TextError;
